import type { CSSProperties } from 'react';
import React from 'react';
import { areEqual } from 'react-window';

import { useStoreState } from '@hotjar/recordings/src/store/player/context';
import { EventBoxElement } from './EventBoxElement';
import { EventBoxTooltip } from './EventBoxTooltip';
import { EventMarker } from '@hotjar/webapp/features/Playbacks/types';

interface PropsForItem {
  data: EventMarker[];
  index: number;
  style: CSSProperties;
}

const PADDING_SIZE = 20;

export const ItemRendererUnMemo = ({ data, index, style }: PropsForItem): JSX.Element => {
  const eventMarker = data[index];
  const { recording } = useStoreState();
  const isDesktopRecording = recording?.device === 'desktop';

  return (
    <div
      style={{
        ...style,
        top: `${parseFloat(style.top as string) + PADDING_SIZE}px`,
      }}
    >
      <EventBoxTooltip eventMarker={eventMarker}>
        <EventBoxElement
          eventMarker={eventMarker}
          isDesktopRecording={isDesktopRecording}
          recordingSiteId={recording?.site_id as number}
        />
      </EventBoxTooltip>
    </div>
  );
};

export const ItemRenderer = React.memo(ItemRendererUnMemo, areEqual);
